const emailRegExp = /^((([^-.]+[\w\d\\.+-]+[^-.])+@([\w\\.][-]?)+\.(\w+))(,)?(\s)?)+$/

export {
    emailRegExp
}